;(function () {

"use strict";

var ResourceTemplate = require('../views/templates/resource.html');
var PaginationTemplate = require('../views/templates/pagination.html');

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function encodeFilters(filters) {
  filters = filters || [];
  return window.encodeURIComponent(filters.join(','));
}

function updateUrlParameters(filters, query, page) {
  if (history.pushState) {
    var filter = encodeFilters(filters) || '';
    query = query || '';
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?f='+filter+'&q='+query+'&page='+page;
    window.history.pushState({ path: newurl }, '', newurl);
  }
}

var PageView = Backbone.View.extend({
  initialize: function () {
    this.client = algoliasearch('808GQH9HV4', '18d27a98c6c38e9629a162b57cd5de4a');
    this.index = this.client.initIndex('parenting_resources');

    this.filters = getParameterByName('f') ? getParameterByName('f').split(',') : [];

    this.initFilterState();

    this.query = getParameterByName('q') || '';
    this.page = parseInt(getParameterByName('page')) - 1 || 0;

    this.$noResults = this.$el.find('#no-results')
    this.$resultsContainer = this.$el.find("#results");
    this.$input = this.$el.find('#search-bar input');

    if (this.query) {
      this.$input.val(this.query);
    }

    this.performSearch(true);

    var self = this;
    this.ajaxSearch = _.debounce(function(e) {
      var val = $(e.currentTarget).val() || '';

      if (val !== self.query) {
        self.page = 0;
        self.query = val;
        self.performSearch();
      }
    }, 250, false);


    $(window).on("popstate", function(e) {
      self.query = getParameterByName('q');
      self.page = parseInt(getParameterByName('page')) - 1 || 0;
      self.$input.val(self.query);
      self.performSearch();
    });

    this.updateUrlParameters = _.debounce(function () {
      updateUrlParameters(self.filters, self.query, self.page+1);
    }, 0, false);
  },
  removeFilter: function(filter) {
    this.filters.splice(this.filters.indexOf(filter), 1);
  },
  addFilter: function (filter) {
    this.filters.push(filter);
  },
  initFilterState: function () {
    var filters = this.filters || [];
    $("#categories .category").each(function () {
      var key = $(this).data('key');

      if (filters.indexOf(key) !== -1) {
        $(this).addClass('active');
      }
    });
  },
  filter: function (e) {
    this.page = 0;

    var $this = $(e.currentTarget);
    var filter = $this.data('key');
    var self = this;

    if (this.filters.indexOf(filter) !== -1) {
      this.removeFilter(filter);
      $this.removeClass('active');
    } else {
      this.addFilter(filter);
      $this.addClass('active');
    }

    this.performSearch();
  },
  performSearch: function(initialRender) {
    var self = this;

    $("#resources").addClass('loading');

    var filters = '';

    if (this.filters.length) {
      filters = this.filters.join(' OR ');
    }

    this.index.search({
      query: this.query,
      hitsPerPage: 10,
      page: this.page,
      filters: filters
    }, function searchDone(err, content) {
        $("#resources").removeClass('loading');

        if (err) { return console.log(err); };

        if (content.hits.length > 0) {
          self.renderResults(content);
        } else {
          self.renderNoResults();
        }

        if (!initialRender) {
          self.updateUrlParameters();
  
          if ($(window).width() < 765) {
            /* Do nothing */
            $(window).scrollTop($('#categories').offset().top);
          } else {
            $(window).scrollTop(0);
          }
        }
    });
  },
  renderResults: function (content) {
    this.$noResults.hide();

    this.$resultsContainer.empty();
    this.$resultsContainer.show();

    var data = content.hits;
    var $content = this.$el.find('#results');

    data.forEach(function(resource) {
      $content.append( $( _.template(ResourceTemplate)({ resource: resource }) ) );
    });
    
    this.renderPagination(content);
  },
  renderPagination: function (content) {
    this.$resultsContainer.append( $( _.template(PaginationTemplate)({ page: this.page, pages: content.nbPages }) ) );
  },
  renderNoResults: function () {
    // console.log('rendering no results');
    this.$resultsContainer.hide();
    this.$noResults.show();
  },
  keyup: function(e) {
    this.ajaxSearch(e);
  },
  events: {
    'click .categories .category': 'filter',
    'click .pagination > span': function (e) {
      var $this = $(e.currentTarget);
      var idx = $this.data('idx');
      if (idx !== undefined && !$this.hasClass('disabled') && idx !== this.page) {

        this.page = parseInt(idx);
        this.performSearch();

        e.preventDefault();
        e.stopPropagation();
      }
    },
    'keyup #search-bar input': 'keyup'
  }
});

module.exports = PageView;

}());